import React from "react";
import "./App.css";
import ImageCarousel from "./ImageCarousel";

function App() {
  const images = [
    "https://picsum.photos/id/1015/800/400",
    "https://picsum.photos/id/1020/800/400",
    "https://picsum.photos/id/1024/800/400",
  ];

  return (
    <div>
      <h1>React Image Carousel 🎠</h1>
      <ImageCarousel images={images} />
    </div>
  );
}

export default App;
